import ApisMethods from './apisMethods'
import {factoryNameToPaySlug, toIsoCurrencyCode} from '../utils/paymentHelpers'

const ServiseFees = {
  get: async (
    searchText: string,
    rowsPerPage: number,
    page: number,
    switchValue: string,
    callBack: any,
    setIsLoading: any
  ) => {
    ApisMethods().get(
      `/vendor/services_fees/${switchValue}?page=${page}&per_page=${rowsPerPage}&search=${searchText}`,
      callBack,
      setIsLoading
    )
  },
  getValue: async (callBack: any, setIsLoading: any) => {
    ApisMethods().get(`/vendor/services_fees/value`, callBack, setIsLoading)
  },
  pay: (data: any, callback: any, setIsLoading: any) => {
    ApisMethods().post(`/vendor/services_fees/pay`, data, callback, setIsLoading)
  },
  confirm: (data: any, callback: any, setIsLoading: any) => {
    ApisMethods().post(`/vendor/services_fees/pay/confirm`, data, callback, setIsLoading)
  },
  startOtp: (serviceFeeId: number | null, callback: any, setIsLoading: any) => {
    ApisMethods().post(
      `/vendor/services_fees/start-otp`,
      serviceFeeId ? {service_fee_id: serviceFeeId} : {},
      callback,
      setIsLoading
    )
  },
  confirmOtp: (data: any, callback: any, setIsLoading: any) => {
    ApisMethods().post(`/vendor/services_fees/confirm-otp`, data, callback, setIsLoading)
  },
  resendOtp: (data: any, callback: any, setIsLoading: any) => {
    ApisMethods().post(`/vendor/common/resend-code`, data, callback, setIsLoading)
  },
  payAll: (callback: any, setIsLoading: any) => {
    ApisMethods().post(`/vendor/services_fees/pay_all`, {}, callback, setIsLoading)
  },
  payWhish: (serviceFeeId: number | null, callback: any, setIsLoading: any) => {
    ApisMethods().post(
      `/vendor/services_fees/pay-whish`,
      {
        ...(serviceFeeId ? {service_fee_id: serviceFeeId} : {}),
        currency_code: toIsoCurrencyCode(),
      },
      callback,
      setIsLoading
    )
  },
  /** POST /vendor/services_fees/pay-{whish|blom|...} — null id = Pay All */
  payByGateway: (
    factoryName: string,
    serviceFeeId: number | null,
    callback: any,
    setIsLoading: any,
    extra?: Record<string, any>
  ) => {
    const slug = factoryNameToPaySlug(factoryName)
    const payload = {
      ...(serviceFeeId ? {service_fee_id: serviceFeeId} : {}),
      ...(extra || {}),
      currency_code: toIsoCurrencyCode(extra?.currency_code),
    }
    ApisMethods().post(`/vendor/services_fees/pay-${slug}`, payload, callback, setIsLoading)
  },
  getOrders: async (
    id: any,

    callBack: any,
    setIsLoading: any,
    rowsPerPage: number,
    page: number
  ) => {
    ApisMethods().get(`/vendor/services_fees/${id}/orders`, callBack, setIsLoading)
    // ?page=${page}&per_page=${rowsPerPage}
  },
}
export default ServiseFees
